import { Flex, Input } from 'antd'
import { FC, useState } from 'react'
import { searchStore } from '../store/search'
import { SearchResult } from '../helpers/types/search'

export const Home: FC = () => {
	const { searchAll } = searchStore()

	const [, setResult] = useState<SearchResult>()

	const search = async (value: string, e: any) => {
		const data = await searchAll(value, 'all')
		setResult(data)
		e.target.value = ''
	}

	return (
		<Flex vertical gap={10}>
			<Input.Search
				placeholder="Поиск"
				variant="filled"
				onSearch={search}
			/>
		</Flex>
	)
}
